import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AssetModel } from '../../models/AssetModel';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ModelProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/model';

  getModels(): Observable<ApiResponse<AssetModel[]>> {
    return this.httpClient.get<ApiResponse<AssetModel[]>>(`${this.baseUrl}/all`);
  }

  upsertModel(model: AssetModel): Observable<ApiResponse<AssetModel>> {
    return this.httpClient.post<ApiResponse<AssetModel>>(`${this.baseUrl}`, model);
  }
}
